import React from 'react'
import gcponwork from '@/assets/img/gcpOnwork.svg'
const OnWorkallcloud = () => {
  return (
    // <div className="sign_container" style={{marginTop:"300px"}}>Working on Page </div>
    <div className='My-onworPage' >
      <img src={gcponwork} alt="" />
      <div className='contianer-first-onwork'>
        <h3 className='heading-onWork' style={{textAlign:"center"}}>All-Cloud Platform  coming soon!</h3>
        <p className='on-work-details'>Sorry, the page you're looking for doesn't exist.</p>

      </div>

    </div>

  )
}

export default OnWorkallcloud